import React from 'react';
import { Subtract } from 'utility-types';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';

import { updatePlaylistUrl } from 'player/services/updatePlaylistUrl';

export type withPlayerDispatcherProps = {
  play: (playlistId: string, playlistItemId: string) => void;
  stop: () => void;
};

/**
 * HOC that provides play() and stop() methods to start
 * playing a provided playlist.
 */
export const withPlayerDispatcher = <P extends withPlayerDispatcherProps>(
  Component: React.ComponentType<P & RouteComponentProps<any>>,
) => {
  // Try to create a nice displayName for React Dev Tools.
  const displayName = Component.displayName || Component.name || 'Component';

  return withRouter(
    class extends React.Component<
      Subtract<P, withPlayerDispatcherProps> & RouteComponentProps<any>
    > {
      public static displayName = `withPlayerDispatcher(${displayName})`;

      constructor(
        props: Subtract<P, withPlayerDispatcherProps> &
          RouteComponentProps<any>,
      ) {
        super(props);
        this.play = this.play.bind(this);
        this.stop = this.stop.bind(this);
      }

      play(playlistId: string, playlistItemId?: string) {
        updatePlaylistUrl(this.props.history, playlistId, playlistItemId);
      }

      stop() {
        updatePlaylistUrl(this.props.history);
      }

      render() {
        return (
          <Component
            {...(this.props as P & RouteComponentProps<any>)}
            stop={this.stop}
            play={this.play}
          />
        );
      }
    },
  );
};
